export enum TileLayerHiDpiModeEnum {
  ShowNextZoomLevel = 'showNextZoomLevel',
  SubstituteLayerShowNextZoomLevel = 'substituteLayerShowNextZoomLevel',
  SubstituteLayerTilePixelRatioOnly = 'substituteLayerTilePixelRatioOnly',
}
